module.exports = __webpack_public_path__ + "img/3.72593981.webp";